import { ApiClientError } from './client';

export interface PeriodItem {
  startDate: string;
  endDate: string;
  status: string;
  isCurrent: boolean;
}

export interface PeriodsResponse {
  periods: PeriodItem[];
}

export async function getPeriods(): Promise<PeriodsResponse> {
  const res = await fetch('/api/timesheet/periods', {
    credentials: 'include',
    headers: { Accept: 'application/json' },
  });
  if (!res.ok) {
    let body: { error?: string; message?: string } | undefined;
    try { body = (await res.json()) as { error?: string; message?: string }; } catch { /* not JSON */ }
    throw new ApiClientError(
      body?.message ?? `${res.status} ${res.statusText}`,
      body?.error ?? `http_${res.status}`,
      res.status,
    );
  }
  return res.json() as Promise<PeriodsResponse>;
}
